<!-- Header da Pagina -->
<div class="page-header">
    <div class="header-icon" [ngSwitch]="true">
        <i *ngSwitchCase="ehTipoTransacaoVenda" class="pi pi-shopping-cart"></i>
        <i *ngSwitchCase="ehTipoTransacaoCompra" class="pi pi-shopping-bag"></i>
        <i *ngSwitchCase="ehTipoTransacaoDevolucao" class="pi pi-undo"></i>
        <i *ngSwitchCase="ehTipoTransacaoDevolucaoDeCompra" class="pi pi-undo"></i>
        <i *ngSwitchDefault class="pi pi-file"></i>
    </div>
    <div class="header-content">
        <h1 class="header-title" [ngSwitch]="true">
            <ng-container *ngSwitchCase="ehTipoTransacaoVenda">
                {{ 'notas-list.texts.lista_de_vendas' | translate }}
            </ng-container>
            <ng-container *ngSwitchCase="ehTipoTransacaoCompra">
                {{ 'notas-list.texts.lista_de_compras' | translate }}
            </ng-container>
            <ng-container *ngSwitchCase="ehTipoTransacaoDevolucao">
                {{ 'notas-list.texts.devolucoes_de_vendas' | translate }}
            </ng-container>
            <ng-container *ngSwitchCase="ehTipoTransacaoDevolucaoDeCompra">
                {{ 'notas-list.texts.devolucoes_de_compras' | translate }}
            </ng-container>
            <ng-container *ngSwitchDefault>
                {{ 'notas-list.texts.lista_de_notas' | translate }}
            </ng-container>
        </h1>
        <p class="header-subtitle" [ngSwitch]="true">
            <ng-container *ngSwitchCase="ehTipoTransacaoVenda">
                {{ 'notas-list.texts.subtitulo_vendas' | translate }}
            </ng-container>
            <ng-container *ngSwitchCase="ehTipoTransacaoCompra">
                {{ 'notas-list.texts.subtitulo_compras' | translate }}
            </ng-container>
            <ng-container *ngSwitchCase="ehTipoTransacaoDevolucao">
                {{ 'notas-list.texts.subtitulo_devolucoes_vendas' | translate }}
            </ng-container>
            <ng-container *ngSwitchCase="ehTipoTransacaoDevolucaoDeCompra">
                {{ 'notas-list.texts.subtitulo_devolucoes_compras' | translate }}
            </ng-container>
            <ng-container *ngSwitchDefault>
                {{ 'notas-list.texts.subtitulo_notas' | translate }}
            </ng-container>
        </p>
    </div>
</div>
<div class="table-wrapper">
    <app-pessoas-table [tipoTransacao]="tipoTransacaoAtual"
      [actionLabel]="actionLabel" [actionRoute]="actionRoute"
      [pessoaId]="pessoaIdFiltro"></app-pessoas-table>
</div>